import UserPlanTag from './UserPlanTag';

export default UserPlanTag;
